import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as translationActions from '../actions/translation.actions';
import * as errorActions from '../actions/error.actions';
import { catchError, of, switchMap } from 'rxjs';
import { TranslationService } from '../../root-services/translation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IError } from '@app-root-interfaces';

@Injectable()
export class TranslationEffects {
    private actions$ = inject(Actions);
    private translationService = inject(TranslationService);

    getDefaultFileTranslation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(translationActions.getDefaultFileTranslation),
            switchMap(({ lang }) =>
                this.translationService.getLanguage(lang).pipe(
                    switchMap((data) => [
                        translationActions.getDefaultFileTranslationSuccess({
                            translation: data
                        })
                    ]),
                    catchError((err: HttpErrorResponse) => {
                        const error: IError = {
                            obj: err,
                            isCritical: true,
                            text: 'translation-error-get'
                        };
                        return of(errorActions.addError({ error }));
                    })
                )
            )
        )
    );

    getFileTranslation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(translationActions.getFileTranslation),
            switchMap(({ lang }) =>
                this.translationService.getLanguage(lang).pipe(
                    switchMap((data) => [
                        translationActions.getFileTranslationSuccess({
                            translation: data
                        })
                    ]),
                    catchError((err: HttpErrorResponse) => {
                        const error: IError = {
                            obj: err,
                            isCritical: true,
                            text: 'translation-error-get'
                        };
                        return of(errorActions.addError({ error }));
                    })
                )
            )
        )
    );
}
